import { JobItem } from 'domains/workspaceDomain';
import { CommonNotes } from '../../common';
import './ProxyNotes.less';

const ProxyNotes = (jobDate: JobItem) => {
  return (
    <div className="proxy-notes-card">
      <CommonNotes {...jobDate} />
    </div>
  );
};

export default ProxyNotes;
